const ListingType = {
  rental: {
    code: 1,
    display: 'Rental',
  },
  roomForRent: {
    code: 5,
    display: 'Room',
  },
};

export default ListingType;
